<template>
  <div>
    <v-row justify="center" no-gutters>
      <v-col cols="12" md="8" lg="6">
        <nav class="navbar">
          <router-link 
            v-for="n in routes"
            :key="n + '-desktop-links'"
            :id="`nav-${n}`"
            :to="`/${n}`"
            class="mb-0 hover-underline-animation">
              {{ n }}
          </router-link>
        </nav>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "AppLayoutLinks",
  data() {
    return {
     routes: ['issues', 'map', 'models'], 
     currentRoute: ''
    }
  },
  watch: {
    currentRoute(newRoute) {
      if (newRoute !== '/map') {
        this.$store.dispatch('contentPanel/updatePanelState', '');
      }
    }
  },    
  mounted() {
    this.currentRoute = this.$router.currentRoute.path;
    if (this.$router.currentRoute.path === '/') {
      document.getElementById('nav-map').classList.add("router-link-exact-active");
    }
  }
}
</script>

<style lang="scss" scoped>
.header-navlinks {
  width: 100vw;
  padding: 24px 0;
  z-index: 1;
  transition: font-size 0.5s;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 24px 0;
  }      
    
  nav.navbar {
    display: flex;
    align-items: center;
    justify-content: space-around;

    a {
      color: #235592;
      text-decoration: unset;
    }

    a.router-link-exact-active {
      border-bottom: 1px solid #DC4B9A;
      font-weight: 700;
    }  
  }

  &.header-navlinks--absolute {
    position: absolute;
    overflow: hidden;
    bottom: 0px;
    
  }    

  &.header-navlinks--fix {  
    position: fixed;
    // top: 92px;
    top: 0;
    bottom: unset;     
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      // top: 80px;
    top: 0;      
    }       
  }
  
  &.header-navlinks--glass {
    background: rgba(250, 250, 250, 0.72);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);     
  }
}
</style>
